// extracted by mini-css-extract-plugin
export var actionButton = "_qa-0";
export var actionMenuContainer = "_qa-i";
export var bubble = "_qa-2";
export var bubbleActionMenu = "_qa-j";
export var bubbleContext = "_qa-6";
export var bubbleItems = "_qa-7";
export var customer = "_qa-3";
export var divider = "_qa-8";
export var fileList = "_qa-9";
export var hiddenComment = "_qa-o";
export var infoAbove = "_qa-a";
export var internal = "_qa-4";
export var lightActionButton = "_qa-1";
export var link = "_qa-b";
export var merchant = "_qa-5";
export var message = "_qa-c";
export var profilePicture = "_qa-e";
export var quillToolbarContainer = "_qa-f";
export var senderDate = "_qa-g";
export var senderDateCustomer = "_qa-h";
export var senderName = "_qa-d";
export var time = "_qa-k";
export var uploadedImage = "_qa-l";
export var username = "_qa-m";
export var xsmall = "_qa-n";